import React from "react";
import "./search.css";

const Search = props => {
  return (
    <div className="search-wrapper">
      <input
        onFocus={() => props.hasFocus && props.hasFocus(true)}
        onBlur={() => props.hasFocus && props.hasFocus(false)}
        name="search"
        type="text"
        value={props.searchValue}
        onChange={props.changed}
        placeholder="Søg..."
      />
    </div>
  );
};

export default Search;
